import {RenderingServices} from '@wallaby-ui/core';

import baseDateFormatterParams from './base_date_formatter_params';
import {I18N} from './base_link_formatter_params';
import {HaidiSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';

type Params = TemplatedCellRendererParams<
  HaidiSchema.components['schemas']['HaiDiscoveryDto']
>;

export interface BaseHaiListLinkFormatterParamsReturnValue {
  id: string | number;
  label: string | undefined;
  searchParams?: {selectedTabs: string};
  titleText: string | number;
}

export function baseHaiListLinkFormatterParams(
  params: Params,
  services: RenderingServices = {}
): BaseHaiListLinkFormatterParamsReturnValue {
  const {intl} = services;
  const {data, value} = params;
  const {formattedValue} = baseDateFormatterParams({
    value: data.encounterStartDate,
  });

  const label = `${value} (${data.patientIdentificationNumber}), ${data.encounterOrganizationShortName}, ${formattedValue}`;

  const id = data.encounterId;
  const titleText = `${intl?.formatMessage(I18N.OPEN_DETAIL)} - ${label}`;

  return {label, id, titleText};
}
